// extracted by mini-css-extract-plugin
export var fadeIn = "_fm-1";
export var modalContent = "_fm-3";
export var overlay = "_fm-0";
export var popoverContent = "_fm-2";
export var results = "_fm-5";
export var searchInputWrapper = "_fm-4";